import { firstSettingsSection, ladderAccess } from '@church/data'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { SETTINGS_TABS } from '../lib/settings-tabs.ts'

/** Settings opens on the first section they may use (the layout sends anyone else home). */
export const Route = createFileRoute('/_authed/_shell/settings/')({
  beforeLoad: ({ context }) => {
    const first = firstSettingsSection(ladderAccess(context.me))
    const tab = SETTINGS_TABS.find((candidate) => candidate.section === first)
    throw redirect({ to: tab?.to ?? '/settings/profile' })
  },
})
